import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { KaizenDetailComponent } from './kaizen-detail/kaizen-detail.component';
import { KaizensComponent } from './kaizens/kaizens.component';
import { AddEditKaizenComponent } from './add-edit-kaizen/add-edit-kaizen.component';
import { CmdreviewComponent } from './cmdreview/cmdreview.component';
import { CmdreviewKaizendetailComponent } from './cmdreview-kaizendetail/cmdreview-kaizendetail.component';
import { MsalGuard } from '@azure/msal-angular';
import { MyKaizensComponent } from './my-kaizens/my-kaizens.component';
import { UserprofileComponent } from './userprofile/userprofile.component';
import { ForecastadjustmentsComponent } from './forecastadjustments/forecastadjustments.component';
import { ActualsComponent } from './actuals/actuals.component';
import { AdvancedsearchComponent } from './advancedsearch/advancedsearch.component';
 


const routes: Routes = [
  { path: '', component: KaizensComponent, pathMatch: 'full', canActivate: [MsalGuard] },
  { path: 'kaizens', component: KaizensComponent, canActivate: [MsalGuard] },
  { path: 'kaizenDetails/:id', component: KaizenDetailComponent, canActivate: [MsalGuard] },
  { path: 'addEditKaizen/:id', component: AddEditKaizenComponent, canActivate: [MsalGuard] },
  { path: 'addEditKaizen', component: AddEditKaizenComponent, canActivate: [MsalGuard] },
  { path: 'cmdreview', component: CmdreviewComponent, canActivate: [MsalGuard] },
  { path: 'cmdrkaizendetail/:id', component: CmdreviewKaizendetailComponent, canActivate: [MsalGuard] },
  { path: 'mykaizens', component: MyKaizensComponent, canActivate: [MsalGuard] },
  { path: 'userprofile', component: UserprofileComponent, canActivate: [MsalGuard] },
  { path: 'forecastadjustments', component: ForecastadjustmentsComponent, canActivate: [MsalGuard] },
  { path: 'actuals/:id', component: ActualsComponent, canActivate: [MsalGuard] },
  { path: 'advancedSearch', component: AdvancedsearchComponent, canActivate: [MsalGuard] }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
